module.exports = "pegasus_template/assets/themecapture1/large/20.png";